import { Observable } from "rxjs";
import { AUTHENTICATION } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const forgotPasswordEpic = (action$, store) => {
    return action$
        .ofType(AUTHENTICATION.FORGOT_PASSWORD.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((body) => {
            return ajax({
                method: "POST",
                body,
                url: `${siteConfig.api}/user/initiate-forgot-password`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (!error) {
                        return [
                            {
                                payload: [],
                                type: AUTHENTICATION.FORGOT_PASSWORD.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage =
                        error.status === 429
                            ? formatMessage("Too many requests. Try later again")
                            : formatMessage("Error generating email");

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: AUTHENTICATION.FORGOT_PASSWORD.COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage })),
                    );
                });
        });
};
